import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "relative z-50 w-full h-full",
  "aria-labelledby": "slide-over-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity"
}
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_4 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_5 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_6 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_7 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl" }
const _hoisted_13 = { class: "flex flex-col gap-4 px-6 sm:px-6" }
const _hoisted_14 = { class: "flex grow flex-col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, "Booking", -1)
const _hoisted_16 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_17 = { class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl px-6 sm:px-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Handling", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
  })
], -1)
const _hoisted_20 = {
  key: 0,
  class: "mt-2 text-gray-700 text-sm w-36 text-center"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "py-3" }
const _hoisted_24 = ["disabled"]

import bookingRepository from '@/repositories/bookings/bookingRepository'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import imageDeleteIcon from '@/assets/icons/image-delete-icon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'bookingActionComponent',
  props: {
  isVisible: Boolean
},
  setup(__props) {

const store = useStore()
const route = useRoute()
const id = route.params.id
const imageReference = ref<string | ArrayBuffer | null | undefined>(null)
const selectedFile = ref<File | null>(null)
const fileInput = ref<File | null>(null)

const props = __props

const close = () => {
  store.dispatch('bookingStore/setBookingActionState', undefined)
}

const details = computed(() => store.getters['bookingStore/booking'])
const actionState = computed(() => store.getters['bookingStore/actionState'])

const buttonText = computed(() => {
  if (!actionState.value) {
    return 'Indlæser'
  }

  if (actionState.value === 'IMAGESTART' || actionState.value === 'IMAGEEND') {
    return 'Tilføj billede'
  }

  if (actionState.value === 'RESUME') {
    return 'Stop pause'
  }

  if (actionState.value === 'RESUME') {
    return 'Stop pause'
  }

  // Triggered when stop is started but not done
  if (actionState.value === 'STOP') {
    return 'Afslut tur - intet gods'
  }

  // Triggered when no stop is started but not done
  if (actionState.value === 'CANCEL') {
    return 'Afslut tur'
  }

  return 'Start pause'
})

const start = async () => {
  if (details.value.status === 3) {
    return
  }

  if (actionState.value === 'PAUSE') {
    const response = await bookingRepository.pauseTemperature(id, { bookingId: id, time: new Date(), user: '-' })
    if (response.data) {
      store.commit('bookingStore/setBookingActionResponse')
      store.dispatch('bookingStore/setBookingActionState', undefined)
    }
  }
  if (actionState.value === 'RESUME') {
    const response = await bookingRepository.resumeTemperature(id, { bookingId: id, time: new Date(), user: '-' })
    if (response.data) {
      store.commit('bookingStore/setBookingActionResponse')
      store.dispatch('bookingStore/setBookingActionState', undefined)
    }
  }
  if (actionState.value === 'CANCEL') {
    const response = await bookingRepository.cancelBooking(id, { bookingId: id, time: new Date(), user: '-' })
    if (response.data) {
      store.commit('bookingStore/setBookingActionResponse')
      store.dispatch('bookingStore/setBookingActionState', undefined)
    }
  }
  if (actionState.value === 'STOP') {
    const response = await bookingRepository.stopBooking(id, { bookingId: id, time: new Date(), user: '-' })
    if (response.data) {
      store.commit('bookingStore/setBookingActionResponse')
      store.dispatch('bookingStore/setBookingActionState', undefined)
    }
  }
  if (actionState.value === 'IMAGESTART' || actionState.value === 'IMAGEEND') {
    const response = await bookingRepository.addImage(id, { bookingId: id, time: new Date(), user: '-', imageReference: imageReference.value, actionState: actionState.value })
    if (response.data) {
      store.commit('bookingStore/setBookingActionResponse')
      store.dispatch('bookingStore/setBookingActionState', undefined)
    }
  }

  store.dispatch('bookingStore/getBooking', id)
}

const actionHasImage = computed(() => {
  if (!actionState.value) {
    return false
  }

  if (actionState.value === 'IMAGESTART' || actionState.value === 'IMAGEEND') {
    return true
  }
  return false
})

const triggerFileInput = () => {
  if (fileInput.value !== null) {
    fileInput.value.click()
  }
}

const imageUrl = computed(() => {
  return selectedFile.value ? URL.createObjectURL(selectedFile.value) : null
})

const removeImage = () => {
  selectedFile.value = null
  imageReference.value = null
  if (fileInput.value) {
    fileInput.value.value = ''
  }
}

const handleFileChange = (event: Event) => {
  const files = (event.target as HTMLInputElement).files
  if (files && files.length > 0) {
    const file = files[0]
    selectedFile.value = file
    const reader = new FileReader()
    reader.onload = (e) => {
      imageReference.value = e.target?.result
    }
    reader.readAsDataURL(file)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, _toDisplayString(details.value.bookingTitle), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        (actionHasImage.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (triggerFileInput())),
                              class: "p-4 border-dashed border-2 h-36 border-gray-300 rounded flex flex-col items-center justify-center relative overflow-visible mb-4"
                            }, [
                              _hoisted_19,
                              (!selectedFile.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Vælg eller tag evt. billede til dokumentation "))
                                : _createCommentVNode("", true),
                              (imageUrl.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: imageUrl.value,
                                    class: "absolute top-0 left-0 w-full h-full object-cover rounded"
                                  }, null, 8, _hoisted_21))
                                : _createCommentVNode("", true),
                              (imageUrl.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 2,
                                    onClick: _withModifiers(removeImage, ["stop"]),
                                    src: _unref(imageDeleteIcon),
                                    class: "absolute -top-3 -right-3 cursor-pointer"
                                  }, null, 8, _hoisted_22))
                                : _createCommentVNode("", true),
                              _createElementVNode("input", {
                                type: "file",
                                ref_key: "fileInput",
                                ref: fileInput,
                                onChange: handleFileChange,
                                accept: "image/*",
                                class: "hidden",
                                capture: "environment"
                              }, null, 544)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            type: "submit",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (start())),
                            disabled: actionHasImage.value && (!selectedFile.value || !imageReference.value),
                            class: _normalizeClass([{ 'opacity-20 pointer-events-none':actionHasImage.value && (!selectedFile.value || !imageReference.value) }, "flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"])
                          }, _toDisplayString(buttonText.value), 11, _hoisted_24)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})